import { render, staticRenderFns } from "./VeranoPage.vue?vue&type=template&id=48fcef63&scoped=true&"
import script from "./VeranoPage.vue?vue&type=script&lang=js&"
export * from "./VeranoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fcef63",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/VeranoPage.vue
// module id = 225
// module chunks = 23